import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'

import { Button } from '@/components/ui/button'
import { Globe } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function LanguageSwitcher() {
	const { t, i18n } = useTranslation()

	const changeLanguage = (lng: string) => {
		i18n.changeLanguage(lng)
	}

	const currentLanguage = i18n.language

	const languageNames: { [key: string]: string } = {
		en: 'English',
		zh: '中文',
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant='outline' size='icon'>
					<Globe className='h-4 w-4' />
					<span className='sr-only'>{t('common.changeLanguage')}</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end'>
				<DropdownMenuItem onClick={() => changeLanguage('en')} disabled={currentLanguage === 'en'}>
					English
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => changeLanguage('zh')} disabled={currentLanguage === 'zh'}>
					中文
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
